import { firstToUpper } from "../../../../../../../utils/helpers/string";
import { renderSettingsResourceLabel } from "../../../../../../../utils/helpers/settings";
import { OldValue } from "../../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../../helpers/historyHelpers/components/NewValue";
import { Label } from "../../../../../helpers/historyHelpers/components/Label";

export const renderItem = (value, label, t) => {
    const newValue = value?.new;
    const oldValue = value?.old;

    let content;

    if (typeof newValue === "boolean") {
        content = (
            <>
                {typeof oldValue === "boolean" && <OldValue value={oldValue ? t("active") : t("not-active")} />}

                <NewValue value={newValue ? t("active") : t("not-active")} />
            </>
        );
    } else if (Array.isArray(newValue) && newValue?.length > 0) {
        const newValueFormatted = (
            <div className="d-flex flex-column justify-content-start align-items-start">
                {newValue.map((item, i) => {
                    if (label === "overtimes") {
                        return (
                            <div key={i}>
                                <span>
                                    {t("start")}: {item.start}
                                </span>
                                ,{" "}
                                <span>
                                    {t("end")}: {item.end}
                                </span>
                                ,{" "}
                                <span>
                                    {t("pay-code")}: {renderSettingsResourceLabel(item.payCode)}
                                </span>
                                {item.premiumPayCode && (
                                    <>
                                        ,{" "}
                                        <span>
                                            {t("premium-pay-code")}:{" "}
                                            {renderSettingsResourceLabel(item.premiumPayCode)}
                                        </span>
                                    </>
                                )}
                            </div>
                        );
                    } else {
                        return <span key={i}>{firstToUpper(item)}</span>;
                    }
                })}
            </div>
        );
        const oldValueFormatted = (
            <div className="d-flex flex-column justify-content-start align-items-start">
                {oldValue.map((item, i) => {
                    if (label === "overtimes") {
                        return (
                            <div key={i}>
                                <span>
                                    {t("start")}: {item.start}
                                </span>
                                ,{" "}
                                <span>
                                    {t("end")}: {item.end}
                                </span>
                                ,{" "}
                                <span>
                                    {t("pay-code")}: {renderSettingsResourceLabel(item.payCode)}
                                </span>
                                {item.premiumPayCode && (
                                    <>
                                        ,{" "}
                                        <span>
                                            {t("premium-pay-code")}:{" "}
                                            {renderSettingsResourceLabel(item.premiumPayCode)}
                                        </span>
                                    </>
                                )}
                            </div>
                        );
                    } else {
                        return <span key={i}>{firstToUpper(item)}</span>;
                    }
                })}
            </div>
        );
        content = (
            <>
                {oldValue.length > 0 && <OldValue value={oldValueFormatted} />}

                <NewValue value={newValueFormatted} />
            </>
        );
    } else if (typeof newValue === "string") {
        content = (
            <>
                {oldValue && <OldValue value={oldValue} />}

                <NewValue value={newValue} />
            </>
        );
    } else if (typeof newValue === "number") {
    } else {
        content = (
            <>
                {oldValue && <OldValue value={renderSettingsResourceLabel(oldValue)} />}

                <NewValue value={renderSettingsResourceLabel(newValue)} />
            </>
        );
    }

    return (
        <div className="d-flex align-items-center gap-2 mb-1 w-100">
            <Label value={t(label)} />
            {content}
        </div>
    );
};
